export const getMapIcon = (color) => {
  const urlSafeColor = color.replace(/#/g, '');
  return `
      <svg width="41" height="58" viewBox="0 0 41 58" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20.6207" cy="20.5595" r="7.13046" fill="white"/>
      <path d="M20.6206 0.624878C9.56346 0.624878 0.620605 9.56774 0.620605 20.6249C0.620605 35.6249 20.6206 57.7677 20.6206 57.7677C20.6206 57.7677 40.6206 35.6249 40.6206 20.6249C40.6206 9.56774 31.6777 0.624878 20.6206 0.624878ZM20.6206 27.7677C16.6777 27.7677 13.4777 24.5677 13.4777 20.6249C13.4777 16.682 16.6777 13.482 20.6206 13.482C24.5635 13.482 27.7635 16.682 27.7635 20.6249C27.7635 24.5677 24.5635 27.7677 20.6206 27.7677Z" fill="%23${urlSafeColor}"/>
      </svg>
  `;
};
